// src/api/organizationApi.js
// Wraps the Spring backend's /organization endpoint (com.experience.organizations.OrganizationController).
import axiosClient from "./axiosClient";

// Creates an organization + first team + first team member + join code in one call.
// The caller's uid comes from the auth token, not this payload.
// Returns { organizationId, teamId, teamMemberId, joinCode }.
export const addOrganization = async ({ organizationName, teamName }) => {
  const response = await axiosClient.post("/organization", {
    organizationName,
    teamName,
  });

  return response.data;
};

// Returns { id, name, leadUid }, or null if it doesn't exist (backend returns 404).
export const getOrganization = async (id) => {
  try {
    const response = await axiosClient.get("/organization", {
      params: { id },
    });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
